import { render } from "./Attendees.vue?vue&type=template&id=86f45554"
import script from "./Attendees.vue?vue&type=script&setup=true&lang=js"
export * from "./Attendees.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Register/Attendees.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86f45554"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86f45554', __exports__)) {
    console.log('reload')
    api.reload('86f45554', __exports__)
  }
  
  module.hot.accept("./Attendees.vue?vue&type=template&id=86f45554", () => {
    console.log('re-render')
    api.rerender('86f45554', render)
  })

}


export default __exports__